import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox, TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke032aResponseMiseisanInfo, Sgke061aRequest, Sgke061aResponseGamenHyojiInfo, Sgke061aResponseInitialhyojiInfo, Szmf033aResponseResponseCustomize } from 'sg-api';
import { UsedSgke061aService } from '../../services/used-sgke061a.service';
import { UsedSzmf033aService } from '../../services/used-szmf033a.service';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke060d-regist',
  templateUrl: './sgke060d-regist.component.html',
  styleUrl: './sgke060d-regist.component.scss'
})
export class Sgke060dRegistComponent implements OnInit, OnDestroy {

  /** 未精算金管理番号 */
  @Input() kinkoMno: string;
  /** 未精算金履歴番号 */
  @Input() kinkoRrkno: string;
  /** 未精算金_更新通番号 */
  @Input() kinkoUpdateSrno: string;
  /** 未精算金EX_更新通番号 */
  @Input() kinkoexUpdatesequencenumber: string;
  /** 返金管理番号 */
  @Input() repayMno: string;
  /** 請求お客さま番号 */
  @Input() recptFixNo: string;

  /** メッセージエミッター */
  @Output() msgEmit = new EventEmitter();
  /** エラーメッセージエミッター */
  @Output() errorMessageEmit = new EventEmitter();
  /** 通常メッセージエミッター */
  @Output() normalMessageEmit = new EventEmitter();
  /** メッセージエリアクリアエミッター */
  @Output() clearMessageEmit = new EventEmitter();
  /** SGKE020D再描画（再検索）エミッター */
  @Output() searchEmit = new EventEmitter();

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** 初期表示APIリクエスト */
  private request061a: Sgke061aRequest;
  /** 初期表示APIレスポンス_初期表示情報 */
  initialhyojiInfo: Sgke061aResponseInitialhyojiInfo;
  /** 初期表示APIレスポンス_画面表示情報 */
  gamenHyojiInfo: Sgke061aResponseGamenHyojiInfo;

  /** 返金結果登録Form FormGroup */
  szmf033aRequestForm: UntypedFormGroup;
  /** 返金報告情報Dto FormGroup */
  repayReportInfDto: UntypedFormGroup;
  /** 登録条件 FormGroup */
  regCndt: UntypedFormGroup;
  /** リクエスト共通エリア FormGroup */
  requestCommon: UntypedFormGroup;
  /** リクエストカスタマイズエリア FormGroup */
  requestCustomize: UntypedFormGroup;

  /** 返金完了区分リスト */
  repayStateDivList: SelectBox[] = [];

  /**
   * コンストラクタ
   * @param {TimeApiService} timeApiService
   * @param {UntypedFormBuilder} fb
   * @param {UsedSgke061aService} searchService
   * @param {UsedSzmf033aService} registService
   * @memberof Sgke060dRegistComponent
   */
  constructor(
    private timeApiService: TimeApiService,
    private fb: UntypedFormBuilder,
    public searchService: UsedSgke061aService,
    public registService: UsedSzmf033aService,
    public listUtils: ListSearchUtils,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke060dRegistComponent
   */
  ngOnInit(): void {
    // フォームを作成
    this.createForm();

    // 初期検索実行
    this.onInitSearch();
  }

  /** 終了処理
   *
   * @memberof Sgke060dRegistComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.szmf033aRequestForm.clearValidators();
    this.szmf033aRequestForm.updateValueAndValidity();
  }

  /**
   * フォーム作成
   * @memberof Sgke060dRegistComponent
   */
  private createForm() {

    // 登録条件 FormGroup
    this.regCndt = this.fb.group({
      // 返金管理番号
      repayMno: [{ value: '', disabled: true }],
      // 返金完了区分
      repayStateDiv: [{ value: '', disabled: true }],
      // 未精算金管理番号
      kinkoMno: [{ value: '', disabled: true }],
      // 未精算金履歴番号
      kinkoRrkno: [{ value: '', disabled: true }],
      // 未精算金EX_更新通番号
      kinkoexUpdatesequencenumber: [{ value: this.kinkoexUpdatesequencenumber, disabled: true }],
      // 返金実績EX_更新通番号
      repayachievexUpdatesequencenumber: [{ value: '', disabled: true }],
      // 支払契約番号
      payCtrNo: [{ value: this.recptFixNo, disabled: true }],
    });

    // リクエストカスタマイズエリア FormGroup
    this.requestCustomize = this.fb.group({
      regCndt: this.regCndt,
    });

    // 返金報告情報Dto FormGroup
    this.repayReportInfDto = this.fb.group({
      // 返金管理番号
      repayMno: [{ value: '', disabled: true }],
      // 返金完了日（返金日SelectList）
      repayFinDate: this.fb.nonNullable.control({ value: '', disabled: false }, Validators.required),
      // 返金完了区分（返金完了区分SelectList）
      repayStateDiv: this.fb.nonNullable.control({ value: null, disabled: false }, Validators.required),
      // 返金メモテキスト
      rcvmnyMemo: [{ value: null, disabled: true }],
      // 返金実績＿更新通番号
      repayAchievUpdateSrno: [{ value: '', disabled: true }],
      // 未精算金管理番号
      kinkoMno: [{ value: '', disabled: true }],
      // 未精算金履歴番号
      kinkoRrkno: [{ value: '', disabled: true }],
      // 未精算金＿更新通番号
      kinkoUpdateSrno: [{ value: this.kinkoUpdateSrno, disabled: true }],
      // 発行年月
      hakkoYmt: [{ value: null, disabled: true }],
      // 請求料金番号
      claimChargeNo: [{ value: null, disabled: true }],
      // 未入金＿件数
      nrcptNumber: [{ value: null, disabled: true }],
      // 未入金＿更新通番号合計
      nrcptUpdateSrnoSum: [{ value: null, disabled: true }],
    });

    // リクエスト共通エリア FormGroup
    this.requestCommon = this.fb.group({
      // 業務日付
      businessDate: [{ value: null, disabled: true }],
      // 取得開始行
      startLine: [{ value: 0, disabled: true }],
      // 取得件数
      getNumber: [{ value: 0, disabled: true }],
      // ドライラン
      dryRun: [{ value: false, disabled: true }],
      // リクエストカスタマイズエリア
      requestCustomize: this.requestCustomize,
    });

    /** 返金結果登録Form */
    this.szmf033aRequestForm = this.fb.group({
      // リクエスト共通エリア FormGroup
      requestCommon: this.requestCommon,
      // 返金報告情報Dto FormGroup
      repayReportInfDto: this.repayReportInfDto

    });
  }

  private onInitSearch() {
    // sgke061aのリクエスト情報をもつオブジェクトを定義
    this.request061a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        startLine: 0,
        getNumber: 0,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      reqBusinessArea: {
        kinkoMno: this.kinkoMno,
        kinkoRrkno: this.kinkoRrkno,
        repayMno: this.repayMno,
      }
    };

    // SGKE061A呼び出し
    this.searchService.doSgke061a(this.request061a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.responseBusinessArea?.gamenHyojiInfo) {
          this.initialhyojiInfo = response.responseBusinessArea.initialhyojiInfo;
          this.gamenHyojiInfo = response.responseBusinessArea.gamenHyojiInfo;
          this.setSelectList();
          this.setFormSgke061a();
        }

        // メッセージを表示
        if (response?.responseCommon?.errors?.length > 0) {
          this.msgEmit.emit(response?.responseCommon?.errors);
        }

      },
      error => {
      }
    );
  }

  /**
   * 選択リストに値を設定
   * @memberof Sgke060dRegistComponent
   */
  private setSelectList() {
    // 返金完了区分リスト
    this.repayStateDivList = this.initialhyojiInfo.repayfinDivList.map((repayStateDiv) => {
      let selectBox: SelectBox = {
        value: repayStateDiv.codeValue,
        viewValue: repayStateDiv.aname
      };
      return selectBox;
    });
  }

  /**
   * フォームにSGKE061Aのレスポンスの値をセット
   * @memberof Sgke060dRegistComponent
   */
  private setFormSgke061a() {
    // 登録条件 FormGroup
    this.regCndt.controls.repayMno.setValue(this.gamenHyojiInfo.basicInfo.repayMno);
    this.regCndt.controls.kinkoMno.setValue(this.gamenHyojiInfo.basicInfo.kinkoMno);
    this.regCndt.controls.kinkoRrkno.setValue(this.gamenHyojiInfo.basicInfo.kinkoRrkno);
    this.regCndt.controls.repayachievexUpdatesequencenumber.setValue(this.gamenHyojiInfo.basicInfo.repayachievexUpdatesequencenumber);
    this.regCndt.controls.repayStateDiv.setValue(this.gamenHyojiInfo.repayResultReport.repayStateDiv.codeValue);

    // 返金報告情報Dto FormGroup
    this.repayReportInfDto.controls.repayMno.setValue(this.gamenHyojiInfo.basicInfo.repayMno);
    var repayStateDiv = this.listUtils.getListboxValue(this.gamenHyojiInfo.repayResultReport.repayStateDiv.codeValue, this.repayStateDivList);
    this.repayReportInfDto.controls.repayStateDiv.setValue(repayStateDiv);
    this.repayReportInfDto.controls.repayAchievUpdateSrno.setValue(this.gamenHyojiInfo.basicInfo.repayAchievUpdateSrno);
    this.repayReportInfDto.controls.kinkoMno.setValue(this.gamenHyojiInfo.basicInfo.kinkoMno);
    this.repayReportInfDto.controls.kinkoRrkno.setValue(this.gamenHyojiInfo.basicInfo.kinkoRrkno);

    // 空文字なら変換なし。
    if (this.gamenHyojiInfo.repayResultReport.repayDate) {
      // 返金予定日
      this.repayReportInfDto.controls.repayFinDate.setValue(this.timeApiService.convertStringToDate(this.gamenHyojiInfo.repayResultReport.repayDate));
    } else {
      // 返金予定日
      this.repayReportInfDto.controls.repayFinDate.setValue(this.gamenHyojiInfo.repayResultReport.repayDate);
    }
  }

  /**
   * 返金完了区分セレクター選択時に、登録情報フォームグループに存在する"repayStateDiv"も更新
   * @param {*} [value]
   * @memberof Sgke060dRegistComponent
   */
  public onChangeSelect(value?) {
    this.regCndt.controls.repayStateDiv.setValue(value);
  }

  /**
   * 登録ボタン押下時
   * @memberof Sgke060dRegistComponent
   */
  public onRegist(): void {
    this.clearMessageEmit.emit();

    this.registService.doSzmf033a(this.szmf033aRequestForm.getRawValue()).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            // メッセージを表示
            if (response?.responseCommon?.errors?.length > 0) {
              this.msgEmit.emit(response?.responseCommon?.errors);
            }
          //カスタマイズエリアから必要な情報を取得
          let szmf033aCustomResponse = <Szmf033aResponseResponseCustomize>response.responseCommon.responseCustomize;
          // 画面遷移用のデータ設定
          let miseisanInfo: Sgke032aResponseMiseisanInfo ={
            kinkoMno:this.gamenHyojiInfo.basicInfo.kinkoMno,
            kinkoRrkno:szmf033aCustomResponse.kinkoRrkno
          };
          // SGKE020D_未精算整理詳細画面の再描画
            this.searchEmit.emit(miseisanInfo);
          }
        },
        error => {
        }
      );
  }

}
